export const LOCAL_BROCHURE = "/bondstein-smarter-spaces-brochure.pdf";

const EMERGENT_RE = /emergent(agent|\.sh)/i;

export function resolveBrochureUrl(url) {
  if (url && !EMERGENT_RE.test(url)) return url;
  return LOCAL_BROCHURE;
}
